import axios from 'axios';

const API_BASE_URL = 'https://api.careoff.in/api/v1';
// const API_BASE_URL = 'http://localhost:5003/api/v1';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to attach the securely stored vendor token globally
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// --- Global API Functions ---

export const loginVendor = async (credentials) => {
    const response = await apiClient.post('/food-vendor/login', credentials);
    return response.data;
};

export const logoutVendor = async () => {
    const response = await apiClient.post('/food-vendor/logout');
    return response.data;
};

export const getVendorProfile = async () => {
    const response = await apiClient.get('/food-vendor/profile');
    return response.data;
};

export const getAllFoodBookings = async (page = 1, limit = 10, search, status) => {
    const response = await apiClient.get('/food/booking/vendor', {
        params: {
            page,
            limit,
            bookingNumber: search || undefined,
            status: status !== 'all' ? status : undefined
        }
    });
    return response.data;
};

export const getFoodBookingById = async (id) => {
    const response = await apiClient.get(`/food/booking/vendor/${id}`);
    return response.data;
};

export const getVendorDashboard = async (fromDate, toDate) => {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await apiClient.get('/food-vendor/dashboard', { params });
    return response.data;
};

export default apiClient;
